import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import moment from "moment"
import {
  Tabbar, TabbarItem,Search,Swipe, SwipeItem,Card,Button,Col, Row,Divider,Grid, GridItem,
  GoodsAction, GoodsActionIcon, GoodsActionButton,ShareSheet,Icon,Toast,List,PullRefresh,
  Cell, CellGroup,Panel,Image as VanImage,ImagePreview,Checkbox,Stepper,SubmitBar,AddressEdit,
  Popup,Tag,Tab, Tabs,Empty,Dialog,NavBar,Overlay,Loading,Form,Field,Step, Steps,CountDown,RadioGroup, Radio,
  CouponCell, CouponList,NoticeBar
} from 'vant';
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true;

Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Search);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Card);
Vue.use(Button);
Vue.use(Col);
Vue.use(Row);
Vue.use(Divider);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(GoodsAction);
Vue.use(GoodsActionIcon);
Vue.use(GoodsActionButton);
Vue.use(ShareSheet);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Panel);
Vue.use(VanImage);
Vue.use(ImagePreview);
Vue.use(Checkbox);
Vue.use(Stepper);
Vue.use(SubmitBar);
Vue.use(AddressEdit);
Vue.use(Popup);
Vue.use(Tag);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Empty);
Vue.use(Dialog);
Vue.use(VueClipboard);
Vue.use(NavBar);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Form);
Vue.use(Field);
Vue.use(Step);
Vue.use(Steps);
Vue.use(CountDown);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CouponCell);
Vue.use(CouponList);
Vue.use(NoticeBar);

Vue.config.productionTip = false;
Vue.prototype.$toast=Toast;
Vue.prototype.$Dialog=Dialog;
Vue.prototype.$imagePreview=ImagePreview;
Vue.prototype.$store = store;
Vue.prototype.$moment = moment;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
